export type ActivityTypeBarStyle = {
  bg: string;
  /** Umriss auf der Balkenfläche – im Dark Mode bewusst gedämpft. */
  border: string;
  /** Farbe für freistehende Marker (Punkt, Strich) ohne eigene Balkenfläche. */
  accent: string;
  text: string;
  /** Fläche der Schraffur bei geplanten Terminen – bereits deckend, nicht halbtransparent. */
  stripe: string;
};

function activityTokens(key: string): ActivityTypeBarStyle {
  return {
    bg: `var(--activity-${key}-bg)`,
    border: `var(--activity-${key}-border)`,
    accent: `var(--activity-${key}-accent)`,
    text: `var(--activity-${key}-text)`,
    stripe: `var(--activity-${key}-stripe)`,
  };
}

/**
 * Plantafel-Balken: mittlere Sättigung (zwischen Pastell und knallig).
 * Die konkreten Farben stehen als Theme-Tokens in `index.css`, damit Light und Dark Mode
 * denselben Balken unterschiedlich einfärben und ein Theme-Wechsel ohne Re-Render greift.
 */
const ACTIVITY_TYPE_BAR_STYLES: Record<string, ActivityTypeBarStyle> = {
  call: activityTokens('call'),
  site_visit: activityTokens('site_visit'),
  meeting: activityTokens('meeting'),
  construction: activityTokens('construction'),
  drive: activityTokens('drive'),
  task: activityTokens('task'),
  training: activityTokens('training'),
  deadline: activityTokens('deadline'),
  email: activityTokens('email'),
  lunch: activityTokens('lunch'),
};

const DEFAULT_BAR_STYLE: ActivityTypeBarStyle = activityTokens('default');

export function activityTypeBarStyle(typeId: string | null | undefined): ActivityTypeBarStyle {
  const key = String(typeId ?? 'task')
    .trim()
    .toLowerCase();
  return ACTIVITY_TYPE_BAR_STYLES[key] ?? DEFAULT_BAR_STYLE;
}

export function googleMapsSearchUrl(address: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address.trim())}`;
}
